<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="organizerForm" v-model="formValid" validate-on="input">
          <v-container>
            <v-row class="pa-2">
              <v-col cols="12">
                <h4 class="text-h6">Veranstalter</h4>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  v-model="name"
                  label="Name des Veranstalters*"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
                <v-checkbox
                  v-model="addContactPerson"
                  label="Kontaktperson hinzufügen"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="pa-2" v-if="addContactPerson">
              <v-col cols="12">
                <h4 class="text-h6">Kontaktperson</h4>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  v-model="contactPersonName"
                  label="Name der Kontaktperson*"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  v-model="contactPersonPhoneNumber"
                  label="Telefonnummer der Kontaktperson*"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  bg-color="accent"
                  variant="filled"
                  v-model="contactPersonEmailAddress"
                  label="E-Mail der Kontaktperson*"
                  :rules="rules.emailRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <ChooseFile
                  :tenant-id="tenantId"
                  v-model="contactPersonImage"
                  images-only
                  background-color="accent"
                  filled
                  label="Foto des Ansprechpartners"
                  forced-subdirectory="events/contacts"
                />
              </v-col>
            </v-row>
            <v-row class="pa-2">
              <v-col cols="12">
                <h4 class="text-h6">Referenten</h4>
              </v-col>
              <v-col cols="12">
                <v-card
                  class="pa-4 mb-4 mx-auto"
                  v-for="speaker in speakers"
                  rounded="xl"
                  :key="speaker.id"
                >
                <div class="d-flex" style="justify-content: space-between;">
                  <h2 class="mb-2">Referent {{ speaker.name }}</h2>
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        absolute
                        location="top right"
                        density="compact"
                        icon
                        variant="text"
                        color="white"
                        class="bg-error"
                        @click="removeSpeaker(speaker.id)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Entfernen</span>
                  </v-tooltip>
                </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        bg-color="accent"
                        variant="filled"
                        v-model="speaker.name"
                        label="Name des Referenten"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        bg-color="accent"
                        variant="filled"
                        type="tel"
                        v-model="speaker.phoneNumber"
                        label="Telefon"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        bg-color="accent"
                        variant="filled"
                        v-model="speaker.emailAddress"
                        placeholder="max.mustermann@web.de"
                        label="E-Mail-Adresse des Referenten"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <ChooseFile
                        :tenant-id="tenantId"
                        v-model="speaker.image"
                        images-only
                        background-color="accent"
                        filled
                        label="Foto des Referenten"
                        forced-subdirectory="events/contacts"
                      />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-tooltip location="bottom" offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn
                      class="bg-primary align-center"
                      color="white"
                      v-bind="props"
                      size="large"
                      icon
                      variant="text"
                      @click="addNewSpeaker"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Referent hinzufügen</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-col cols="12" class="text-subtitle-2">*Pflichtfelder</v-col>
          </v-container>
        <Pager :invalid="!formValid" />
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Pager from "@/components/Events/Form/Pager";
import uniqueId from "lodash/uniqueId";
import ChooseFile from "@/components/Files/ChooseFile.vue";

export default {
  components: {
    ChooseFile,
    Pager,
  },
  data() {
    return {
      formValid: false,
      rules: {
        required: (value) => !!value || "Pflichtfeld",
        emailRules: [
          (v) => !!v || "E-Mail ist erforderlich",
          (v) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-Mail muss gültig sein",
        ],
      },
    };
  },
  methods: {
    ...mapActions({
      updateValue: "events/updateForm",
      addSpeaker: "events/addSpeaker",
      removeSpeaker: "events/removeSpeaker",
    }),
    addNewSpeaker() {
      this.addSpeaker({
        id: uniqueId(),
        phoneNumber: "",
        emailAddress: "",
      });
    },
    goBack() {
      this.$router.push({ name: "events" });
    },
  },
  computed: {
    ...mapGetters({
      form: "events/form",
      speakers: "events/speakers",
      tenantId: "tenants/currentTenantId",
    }),
    name: {
      get() {
        return this.$store.state.events.form.eventOrganizer.name;
      },
      set(value) {
        this.updateValue({
          parent: "eventOrganizer",
          field: "name",
          value: value,
        });
      },
    },
    addContactPerson: {
      get() {
        return this.$store.state.events.form.eventOrganizer.addContactPerson;
      },
      set(value) {
        this.updateValue({
          parent: "eventOrganizer",
          field: "addContactPerson",
          value: value,
        });
      },
    },
    contactPersonName: {
      get() {
        return this.$store.state.events.form.eventOrganizer.contactPersonName;
      },
      set(value) {
        this.updateValue({
          parent: "eventOrganizer",
          field: "contactPersonName",
          value: value,
        });
      },
    },
    contactPersonPhoneNumber: {
      get() {
        return this.$store.state.events.form.eventOrganizer
          .contactPersonPhoneNumber;
      },
      set(value) {
        this.updateValue({
          parent: "eventOrganizer",
          field: "contactPersonPhoneNumber",
          value: value,
        });
      },
    },
    contactPersonEmailAddress: {
      get() {
        return this.$store.state.events.form.eventOrganizer
          .contactPersonEmailAddress;
      },
      set(value) {
        this.updateValue({
          parent: "eventOrganizer",
          field: "contactPersonEmailAddress",
          value: value,
        });
      },
    },
    contactPersonImage: {
      get() {
        return this.$store.state.events.form.eventOrganizer.contactPersonImage;
      },
      set(value) {
        this.updateValue({
          parent: "eventOrganizer",
          field: "contactPersonImage",
          value: value,
        });
      },
    },
  },
};
</script>

<style scoped></style>
